module.exports = __webpack_public_path__ + "img/coat_2.a6a09405.png";